@use '../../styling/colors.scss' as *;
@use '../../styling/typography.scss' as *;

.Breadcrumb {
  display: inline-flex;
  align-items: center;

  h1 {
    @extend %font-family-primary;

    color: $theme-color-text;
    font-size: $font-size-normal;
    display: flex;
    font-weight: $font-weight-semibold;
    margin: 0;
    margin-left: 0.25em;
    column-gap: 3px;
  }

  .Title {
    word-wrap: break-word;
    max-width: 400px;
  }

  .Divider {
    height: 1.25em;
    margin: 0 12px;
  }
}
